import { Section } from "../types";

export const sections_en: Section[] = [
  {
    title: "Learning Style Assessment",
    questions: [
      {
        question:
          "Which subjects do you like the most in the period 9 - 12 grades? (you can mark a minimum of 1 and a maximum of 2)",
        options: [
          {
            option: "Bulgarian language and literature",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
          {
            option: "Foreign languages",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
            },
          },
          {
            option: "Biology/Chemistry",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option: "Physics",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
            },
          },
          {
            option: "Mathematics",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
            },
          },
          {
            option: "Geography",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option:
              "Economics/Entrepreneurship or other similar subjects from commercial and financial vocational high schools",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option: "History",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option: "Philosophy/Psychology",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option:
              "IT/computer programming or other technology subjects from vocational high schools",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Civic education",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option:
              "Arts/design or other similar subjects from vocational art high schools",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option: "Music/dance/acting",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
            },
          },
          {
            option: "Physical education and sports",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
            },
          },
        ],
        multiSelect: true,
        minSelect: 1,
        maxSelect: 2,
      },
      {
        question:
          "Which of these subjects did you choose as your core subjects at school? (you can mark a minimum of 1 and a maximum of 4)",
        options: [
          {
            option: "Bulgarian language and literature",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Foreign languages",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
            },
          },
          {
            option: "Biology/Chemistry",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option: "Physics",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
            },
          },
          {
            option: "Mathematics",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
            },
          },
          {
            option: "Geography",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option:
              "Economics/Entrepreneurship or other similar subjects from commercial and financial vocational high schools",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option: "History",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
            },
          },
          {
            option: "Philosophy/Psychology",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option:
              "IT/computer programming or other technology subjects from vocational high schools",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Civic education",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option:
              "Arts/design or other similar subjects from vocational art high schools",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option: "Music/dance/acting",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
            },
          },
          {
            option: "Physical education and sports",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
            },
          },
        ],
        multiSelect: true,
        minSelect: 1,
        maxSelect: 4,
      },
      {
        question: "How do you feel about mathematics?",
        options: [
          {
            option: "With pleasure and desire",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option: "I accept it and deal with it well if it is needed.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "I'm OK, only when it's applicable in practice",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option: "I prefer to avoid it.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option: "I don't like math.",
            scores: {
              "MO/POLITICS": 4,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
            },
          },
        ],
      },
      {
        question: "What type of homework do you do best and enjoy the most?",
        options: [
          {
            option: "Logical and mathematical problems",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
            },
          },
          {
            option: "Writing an essay",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
            },
          },
          {
            option: "Scientific/research projects",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Preparing an individual presentation",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
          {
            option: "Group project/presentation",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
            },
          },
          {
            option:
              "Opportunity for self-expression, creativity and critical thinking",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 3,
              "DESIGNERS AND ETC.": 3,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
        ],
      },
      {
        question:
          "How do you learn new information / a new lesson most easily?",
        options: [
          {
            option: "Through logic and practice",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 1,
            },
          },
          {
            option: "By reading and extracting the important information",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
            },
          },
          {
            option: "by memorizing the entire text and retelling it",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
            },
          },
          {
            option: "Through analysis and discussion of the topic",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 1,
            },
          },
          {
            option: "Through drawings, graphs, to remember it visually",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 2,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 3,
            },
          },
          {
            option:
              "Through associations with other topics/events/personalities",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
        ],
      },
      {
        question:
          "What role do you like to play in the team when preparing a joint project at school?",
        options: [
          {
            option:
              "You choose the preparation strategy and distribute the tasks.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option:
              "You write the text of the project because you express yourself best.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
            },
          },
          {
            option: "You are the one looking for information.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 3,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 2,
              "Translator/teacher": 3,
            },
          },
          {
            option: "You present the project to the teachers.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
          {
            option: "You design the graphics and slides of the presentation.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
          {
            option:
              "I love taking part in all the parts above because I can do them all well.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
        ],
      },
      {
        question:
          "What course would you enroll in or practice in your free time?",
        options: [
          {
            option: "Computers or programming",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Creative writing or philosophy",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
            },
          },
          {
            option: "Experiments and research",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option: "Digital Marketing",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
            },
          },
          {
            option: "Debates",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
            },
          },
          {
            option: "Related to drawing",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option: "Music or acting",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
          {
            option: "Business club",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Something related to charity work",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
        ],
      },
      {
        question: "What do you value most in the learning process?",
        options: [
          {
            option: "When the lesson is structured and logically directed",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 2,
            },
          },
          {
            option:
              "When you have the right to your own opinion and critical thinking",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 3,
              "WORK IN A GALLERY/MUSEUM/ART": 3,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 3,
              "Translator/teacher": 1,
            },
          },
          {
            option: "When the lesson is related to nature and health",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
          {
            option:
              "When the lesson is about research, analysis, and decision-making",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Freedom of creativity and self-expression",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
            },
          },
        ],
      },
      {
        question: "What inspires you when you imagine the future?",
        options: [
          {
            option: "New innovations and technologies",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option:
              "Psychology and how it helps people to understand themselves and build in the right direction by making sound and well-considered decisions",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option:
              "Discoveries in medicine and other scientific fields that change our lives and daily routines",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "Famous people like Bill Gates, Elon Musk",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
          {
            option: "Creating innovative buildings and designs",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
          {
            option:
              "The Instagram space and influencers who live the best life I dream of",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Behavior",
    questions: [
      {
        question: "What is your tolerance for stressful situations?",
        options: [
          {
            option: "I cope well under stress and pressure.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 3,
            },
          },
          {
            option: "Stress is a challenge, but I can handle it.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option: "I try to avoid stressful conflicts.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
          {
            option: "I work much better in a calm environment.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option: "I can't concentrate in stressful moments.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
            },
          },
        ],
      },
      {
        question:
          "How do you react when someone asks you for help, even though you're not really very competent in the field?",
        options: [
          {
            option: "I believe I am intelligent enough to help in any field.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
            },
          },
          {
            option:
              "I would help out of politeness, even if I'm not completely clear on the topic.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
            },
          },
          {
            option:
              "would warn you in advance that I am not competent in this field, but I believe that together we will find a way and a solution.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
            },
          },
          {
            option: "I would rather refuse to help than let someone down.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
            },
          },
        ],
      },
      {
        question: "You are late with your project due date, what will you do?",
        options: [
          {
            option:
              "I'll pass it on to where I'm at and apologize to the teacher.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
          {
            option:
              "I'll give as an excuse that I was sick, I wasn't feeling well, and that's the reason.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
          {
            option: "I will talk to the teacher in advance about a deferral.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 1,
            },
          },
          {
            option:
              "I'll spend the whole night on the computer until I finish it.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
            },
          },
          {
            option: "I'm never late!",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
        ],
      },
      {
        question:
          "You see a classmate cheating, and he constantly brags about being the smartest in the class. How would you react?",
        options: [
          {
            option:
              "It's none of my business, there are teachers who need to see it.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
            },
          },
          {
            option:
              "I will go carefully and inform the teacher without the whole class finding out.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 3,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 1,
              "Translator/teacher": 1,
            },
          },
          {
            option:
              "I'll make fun of him by getting up and publicly exposing him in front of his classmates and the teacher.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
          {
            option: "No matter how much he copies, he can't make more than me.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 4,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
        ],
      },
      {
        question:
          "When you're arguing with someone who has equally strong arguments",
        options: [
          {
            option: "I'm inclined to back down and accept their side as true.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 1,
            },
          },
          {
            option:
              "would not back down, considering that I am convinced of the truth of my arguments.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 1,
            },
          },
          {
            option:
              "I will find a common solution that satisfies both parties.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 2,
            },
          },
          {
            option: "I will use distorted arguments to weaken his version.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
            },
          },
        ],
      },
      {
        question:
          "You are watching your favorite show live in a theater. Suddenly, the host points to you and invites you on stage as part of a stage act/game.",
        options: [
          {
            option: "You are super enthusiastic and jump right on stage.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option: "Of course I'll join in as soon as they put me on TV.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option: "I would feel special, but I would rather say no.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 1,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 1,
              "Translator/teacher": 1,
            },
          },
          {
            option: "I definitely refuse.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
            },
          },
          {
            option:
              "I'd rather leave right now because I'd die of embarrassment.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
            },
          },
        ],
      },
      {
        question:
          "Someone owes you money, but you find them shopping for clothes?",
        options: [
          {
            option: "You'll politely ask him to give them back to me.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 1,
              "ACTORS/MUSICIANS": 2,
            },
          },
          {
            option: "I will invite him to lunch/dinner and make him pay.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
            },
          },
          {
            option: "I will post something indirectly on social media.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
            },
          },
          {
            option: "I'll meet him and I'll find him there.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Skills",
    questions: [
      {
        question: "Do you prefer to work in a team or alone?",
        options: [
          {
            option: "I prefer to do my own work.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 1,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 3,
            },
          },
          {
            option: "I can work equally well in a team and independently.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
            },
          },
          {
            option:
              "I like working in a group where we can exchange ideas and experiences.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
            },
          },
        ],
      },
      {
        question:
          "Do you prefer to lead and take responsibility or follow and complete tasks?",
        options: [
          {
            option: "I always demonstrate my leadership qualities.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
            },
          },
          {
            option: "I do well in both roles.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
            },
          },
          {
            option: "I don't like taking responsibility.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
            },
          },
        ],
      },
      {
        question:
          "Do you like to experiment and try new things or do you prefer the status quo and not change?",
        options: [
          {
            option:
              "I prefer to use proven methods without the risk of errors.",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
            },
          },
          {
            option:
              "I tend to try new things from time to time without overdoing it.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
            },
          },
          {
            option:
              "I love experimenting with myself, with circumstances and everything around me.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
            },
          },
        ],
      },
      {
        question:
          "Can you identify with one of the 3 types of people and which one?",
        options: [
          {
            option: "Introvert",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 3,
            },
          },
          {
            option:
              "I think I'm a little bit of both without being at either extreme.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 1,
              "COSMONAUT/DISCOVERER": 1,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 1,
            },
          },
          {
            option: "Extrovert and the soul of the company",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
            },
          },
        ],
      },
      {
        question: "You win a plane ticket for two to New York as a prize?",
        options: [
          {
            option:
              "First I'll look for someone who would agree to come with me.",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 3,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 3,
              "ARCHITECTURE/CONSTRUCTION": 2,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 2,
              "WORK IN A GALLERY/MUSEUM/ART": 2,
              "DESIGNERS AND ETC.": 3,
              "ACTORS/MUSICIANS": 2,
              "Translator/teacher": 2,
            },
          },
          {
            option:
              "I've already booked the hotel and am packing, regardless of whether anyone wants to come or not.",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option:
              "I will discuss with my parents/brother/sister who would accompany me - it's the other side of the world after all",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 2,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 3,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 1,
              "ARCHITECTURE/CONSTRUCTION": 3,
              "LEGAL PROFESSIONS/JUDGE/NOTARY": 1,
              "WORK IN A GALLERY/MUSEUM/ART": 3,
            },
          },
        ],
      },
    ],
  },
  {
    title: "Career Preferences",
    questions: [
      {
        question: "Choose one profession from each pair:",
        type: "profession-choice",
        options: [
          {
            option: "Cosmonaut",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 2,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
              "GOVERNMENT WORK": 2,
              "COSMONAUT/DISCOVERER": 2,
              "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
            },
          },
          {
            option: "Government job at the Ministry of Health",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
            },
          },
          {
            option: "TV show host",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
          {
            option: "Industrial engineer",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Pre-drinker",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
              "MILITARY/DEFENSE": 1,
              "GOVERNMENT WORK": 1,
            },
          },
          {
            option: "Banker",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
            },
          },
          {
            option: "Doctor",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Architect",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 3,
            },
          },
          {
            option: "Product designer",
            scores: {
              "MO/POLITICS": 2,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 3,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              "MILITARY/DEFENSE": 1,
            },
          },
          {
            option: "Diplomat",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 3,
              "MARKETING PR ADVERTISING EVENTS": 2,
              "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              "MILITARY/DEFENSE": 2,
            },
          },
          {
            option: "Children's teacher",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 3,
            },
          },
          {
            option: "Laboratory assistant",
            scores: {
              "MO/POLITICS": 3,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
              "MEDIA COMMUNICATIONS PR": 2,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
          {
            option: "HR specialist",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 2,
            },
          },
          {
            option: "Hotel receptionist",
            scores: {
              "MO/POLITICS": 1,
              "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
              "ENGINEERING AND ARCHITECTURE": 1,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
              "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
              "MEDIA COMMUNICATIONS PR": 1,
              "MARKETING PR ADVERTISING EVENTS": 1,
            },
          },
        ],
        professionPairs: [
          [
            {
              option: "Cosmonaut",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 2,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 3,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
                "MILITARY/DEFENSE": 3,
                "GOVERNMENT WORK": 2,
                "COSMONAUT/DISCOVERER": 2,
                "ECOLOGY/SUSTAINABILITY/INNOVATION": 2,
              },
            },
            {
              option: "Government job at the Ministry of Health",
              scores: {
                "MO/POLITICS": 2,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
              },
            },
          ],

          [
            {
              option: "TV show host",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 3,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 3,
                "MARKETING PR ADVERTISING EVENTS": 3,
              },
            },
            {
              option: "Industrial engineer",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 3,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 2,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
                "MILITARY/DEFENSE": 1,
              },
            },
          ],

          [
            {
              option: "Pre-drinker",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 1,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 2,
                "MILITARY/DEFENSE": 1,
                "GOVERNMENT WORK": 1,
              },
            },
            {
              option: "Banker",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
                "MEDIA COMMUNICATIONS PR": 2,
                "MARKETING PR ADVERTISING EVENTS": 1,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
              },
            },
          ],

          [
            {
              option: "Doctor",
              scores: {
                "MO/POLITICS": 3,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 2,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
                "MILITARY/DEFENSE": 1,
              },
            },
            {
              option: "Architect",
              scores: {
                "MO/POLITICS": 3,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
                "MILITARY/DEFENSE": 3,
              },
            },
          ],

          [
            {
              option: "Product designer",
              scores: {
                "MO/POLITICS": 2,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 1,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 3,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3,
                "MILITARY/DEFENSE": 1,
              },
            },
            {
              option: "Diplomat",
              scores: {
                "MO/POLITICS": 3,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 2,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 3,
                "MARKETING PR ADVERTISING EVENTS": 2,
                "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 1,
                "MILITARY/DEFENSE": 2,
              },
            },
          ],

          [
            {
              option: "Children's teacher",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 2,
                "MARKETING PR ADVERTISING EVENTS": 3,
              },
            },
            {
              option: "Laboratory assistant",
              scores: {
                "MO/POLITICS": 3,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 2,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 1,
                "MEDIA COMMUNICATIONS PR": 2,
                "MARKETING PR ADVERTISING EVENTS": 1,
              },
            },
          ],

          [
            {
              option: "HR specialist",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 2,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 2,
              },
            },
            {
              option: "Hotel receptionist",
              scores: {
                "MO/POLITICS": 1,
                "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3,
                "ENGINEERING AND ARCHITECTURE": 1,
                "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
                "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1,
                "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 2,
                "MEDIA COMMUNICATIONS PR": 1,
                "MARKETING PR ADVERTISING EVENTS": 1,
              },
            },
          ],
        ],
      },
    ],
  },
  {
    title: "Professional Tasks Matching",
    questions: [
      {
        question: "Match each profession with the corresponding task:",
        type: "profession-task",
        options: [],
        pairs: [
          {
            profession: "Financial Analyst",
            task: "Banking/Stock Exchange Operations",
            scores: {
              "FINANCE/BANKS/COMMODITY EXCHANGES/DATA SCIENCE/ACCOUNTING": 3,
            },
          },
          {
            profession: "Graphic Designer",
            task: "Creating Billboards and Brochures",
            scores: { "MARKETING PR ADVERTISING EVENTS": 3 },
          },
          {
            profession: "Member of Parliament",
            task: "European Parliament Representative",
            scores: { "MO/POLITICS": 3, "GOVERNMENT WORK": 2 },
          },
          {
            profession: "Entrepreneur",
            task: "Business Owner",
            scores: { "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 3 },
          },
          {
            profession: "Journalist",
            task: "Newspaper/Magazine Writing",
            scores: { "MEDIA COMMUNICATIONS PR": 3 },
          },
          {
            profession: "Sociologist",
            task: "Public Opinion Research and Analysis",
            scores: { "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3 },
          },
          {
            profession: "Nuclear Engineer",
            task: "Nuclear Power Plant Operations",
            scores: {
              "ENGINEERING AND ARCHITECTURE": 3,
              "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 1,
            },
          },
          {
            profession: "Game Designer",
            task: "Minecraft",
            scores: { "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3 },
          },
          {
            profession: "Director",
            task: "Theater/Film Production",
            scores: { "MEDIA COMMUNICATIONS PR": 3 },
          },
          {
            profession: "Historian",
            task: "Museum Curation",
            scores: { "WORK IN A GALLERY/MUSEUM/ART": 3 },
          },
          {
            profession: "Philologist",
            task: "Translation Services",
            scores: { "TRANSLATOR/TEACHER": 3 },
          },
          {
            profession: "Architect",
            task: "Building Design and Construction",
            scores: { "ARCHITECTURE/CONSTRUCTION": 3 },
          },
          {
            profession: "Security Officer", // Changed from "Beretta"
            task: "Public Order Maintenance",
            scores: { "MILITARY/DEFENSE": 3 },
          },
          {
            profession: "Therapist",
            task: "Mental Health Counseling",
            scores: { "PSYCHOLOGY/SOCIOLOGY/PHILOSOPHY": 3 },
          },
          {
            profession: "Marketing Specialist",
            task: "Campaign Development and Management",
            scores: { "MARKETING PR ADVERTISING EVENTS": 3 },
          },
          {
            profession: "SEO Specialist",
            task: "Digital Platform Optimization",
            scores: { "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3 },
          },
          {
            profession: "Model",
            task: "Brand and Fashion Representation",
            scores: { "MEDIA COMMUNICATIONS PR": 2 },
          },
          {
            profession: "Barista",
            task: "Coffee Service and Preparation",
            scores: { "BUSINESS/MANAGEMENT/ENTREPRENEURSHIP/HOSPITALITY": 1 },
          },
          {
            profession: "AI Engineer",
            task: "Artificial Intelligence Development",
            scores: { "IT/COMPUTERS/DATA SCIENCE/ROBOTICS": 3 },
          },
          {
            profession: "Biochemist",
            task: "Laboratory Research",
            scores: { "BIOLOGY/MEDICINE/NUTRITIONIST/ENVIRONMENTAL": 3 },
          },
          {
            profession: "Lawyer",
            task: "Legal Representation and Advocacy",
            scores: { "LEGAL PROFESSIONS/JUDGE/NOTARY": 3 },
          },
          // ... add all your pairs here
        ],
        availableProfessions: [
          "Lawyer",
          "Game Designer",
          "Marketing Specialist",
          "SEO Specialist",
          "Director",
          "Nuclear Engineer",
          "Journalist",
          "Graphic Designer",
          "Barista",
          "Architect",
          "AI Engineer",
          "Model",
          "Philologist",
          "Sociologist",
          "Therapist",
          "Entrepreneur",
          "Security Officer",
          "Member of Parliament",
          "Financial Analyst",
          "Biochemist",
          "Historian",
          // ... add all professions
        ],
        availableTasks: [
          "Banking/Stock Exchange Operations",
          "Creating Billboards and Brochures",
          "European Parliament Representative",
          "Business Owner",
          "Newspaper/Magazine Writing",
          "Public Opinion Research and Analysis",
          "Nuclear Power Plant Operations",
          "Minecraft",
          "Theater/Film Production",
          "Museum Curation",
          "Translation Services",
          "Building Design and Construction",
          "Public Order Maintenance",
          "Mental Health Counseling",
          "Campaign Development and Management",
          "Digital Platform Optimization",
          "Brand and Fashion Representation",
          "Coffee Service and Preparation",
          "Artificial Intelligence Development",
          "Laboratory Research",
          "Legal Representation and Advocacy",
          // ... add all tasks
        ],
      },
    ],
  },
];
